export default {
  get_all: { method: 'get', url: 'api/physical-people' },
  show: { method: 'get', url: 'api/physical-people{/id}' },
  store: { method: 'post', url: 'api/physical-people' },
  update: { method: 'put', url: 'api/physical-people{/id}' },
  delete: { method: 'delete', url: 'api/physical-people{/id}' }
}
